/* eslint-disable import/prefer-default-export */
import { dateConvertDdMmmYyyyHhMm, dateConvertToDay } from "Helpers/utils";
import { useEffect, useState } from "react";
import moment from "moment";

export const useDebounceValue = (value, delay) => {

	const [debouncedValue, setDebouncedValue] = useState(
		value,
	);

	useEffect(() => {

		const handler = setTimeout(() => {

			setDebouncedValue(value);

		}, delay);

		return () => {

			clearTimeout(handler);

		};

	}, [value]);

	return debouncedValue;

};

export const useGetAppliedHook = ({
	addCondition = true,
	getStoreAppliedPromotion,
	isLoadAppliedPromotion,
	setHasMultiCoupon,
	setPromo,
	promo,
}) => useEffect(() => {

	/* Promotion Feature */
	// biar auto centang di list promo nya setelah load applied
	const multipleCoupon = [];
	if (addCondition
		&& Array.isArray(getStoreAppliedPromotion) && promo?.length > 0) {

		const newData = promo.map((item) => {

			if (item?.coupon.length > 0 && getStoreAppliedPromotion?.includes(item?.coupon[0].code)) {

				// eslint-disable-next-line no-param-reassign
				item.selected = true;
				// eslint-disable-next-line no-param-reassign
				item.isApply = true;
				multipleCoupon.push(item.stop_multi_coupon);

			} else {

				// eslint-disable-next-line no-param-reassign
				item.selected = false;
				// eslint-disable-next-line no-param-reassign
				item.isApply = false;

			}
			return item;

		});
		setHasMultiCoupon(multipleCoupon);
		setPromo(newData);

	}

}, [isLoadAppliedPromotion]);

export const useMaxPayment = (
	datetime,
	isWithDay = false,
	amountOfTime = 2,
	unitOfTime = "hours", // "days", "hours", "minutes", "seconds", "milliseconds"
) => {

	const [formattedDatetime, setFormattedDatetime] = useState("");

	useEffect(() => {

		const day = dateConvertToDay(moment(datetime).add(amountOfTime, unitOfTime));
		const dateAndTime = dateConvertDdMmmYyyyHhMm(moment(datetime).add(amountOfTime, unitOfTime));

		setFormattedDatetime(`${isWithDay ? `${day}, ` : ""}${dateAndTime}`);

	}, [datetime]);

	return formattedDatetime;

};
